import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { EventsThemeShape } from "@faire/web--source/slate/Theme/EventsThemeShape";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";
import { AnimatedValueProps } from "@faire/retailer/features/FaireMarkets/ValueProps/AnimatedValueProps";
export var HomeFaireMarketValueProps = function() {
    var layoutElement = React.useContext(Context).layoutElement;
    var valueProps = function() {
        return layoutElement.layout_element_data.map(function(valueProps) {
            var simpleTextTile = valueProps.simple_text_tile;
            return {
                title: simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.main_text,
                description: simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.description_text,
                ctaLink: (simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.cta_link) && (simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.cta_text) ? /*#__PURE__*/ _jsx(Button, {
                    linkTo: simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.cta_link,
                    variant: "tertiary",
                    children: simpleTextTile === null || simpleTextTile === void 0 ? void 0 : simpleTextTile.cta_text
                }) : null
            };
        });
    };
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: FaireMarketTheme,
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                    tabletAndAbove: /*#__PURE__*/ _jsx(StyledMarketBadge, {
                        width: "124px"
                    }),
                    mobile: /*#__PURE__*/ _jsx(StyledMarketBadge, {
                        width: "92px"
                    })
                }),
                /*#__PURE__*/ _jsxs(Content, {
                    children: [
                        /*#__PURE__*/ _jsx(Header, {
                            children: layoutElement.main_text
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "5x"
                        }),
                        /*#__PURE__*/ _jsx(StyledAnimatedValueProps, {
                            valueProps: valueProps(),
                            textColor: Core.text.default
                        })
                    ]
                })
            ]
        })
    });
};
var Container = styled.div.withConfig({
    componentId: "sc-dbed0214-0"
})([
    "overflow:hidden;position:relative;max-width:1280px;padding:",
    ";margin:0 auto;background-color:",
    ";",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], getSpacing(112, "7x", 104), eventsThemeColors.faireMarket.lightBackground, responsiveMediaQueries.tablet, getSpacing("5x", "7x"), responsiveMediaQueries.mobile, getSpacing("5x", "3x"));
var Content = styled(Column).attrs({
    align: {
        mobileAndAbove: "normal",
        tabletAndAbove: "center",
        desktopAndAbove: "normal"
    }
}).withConfig({
    componentId: "sc-dbed0214-1"
})([
    ""
]);
var Header = styled(Typography).attrs({
    variant: {
        desktopAndAbove: "displayMSerifRegular",
        tabletAndAbove: "displaySSerifRegular",
        mobileAndAbove: "pageHeaderSerifRegular"
    }
}).withConfig({
    componentId: "sc-dbed0214-2"
})([
    "&&&{",
    "{max-width:663px;}",
    "{z-index:1;}",
    "{margin-right:60px;}}"
], responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
var StyledAnimatedValueProps = styled(AnimatedValueProps).withConfig({
    componentId: "sc-dbed0214-3"
})([
    "",
    "{padding:unset;}"
], responsiveMediaQueries.tablet);
var StyledMarketBadge = styled(EventsThemeShape.faireMarket.badge).attrs({
    color: eventsThemeColors.faireMarket.badgeIcon
}).withConfig({
    componentId: "sc-dbed0214-4"
})([
    "position:absolute;top:",
    ";right:",
    ";",
    "{top:",
    ";right:-",
    ";}"
], getSpacing("10x"), getSpacing("10x"), responsiveMediaQueries.tabletAndBelow, getSpacing("4x"), getSpacing("4x"));
